import React from 'react';
import { useSelector } from 'react-redux';
import CartItem from './CartItem/CartItem';

function CartItems() {
  // Getting data from redux store
  const cartItems = useSelector(state => state.cartItems);
  return (
    <div className="space-y-6">
      {/* Render all cart component */}
      {cartItems.length > 0 ? (
        cartItems?.map(cartItem => (
          <CartItem key={cartItem.productId} cartItem={cartItem} />
        ))
      ) : (
        <h1>No product found in Cart</h1>
      )}
    </div>
  );
}

export default CartItems;
